import "preact/debug"
import { render } from "htm/preact"

import { RoundTables } from './Roundtables.js'

console.log(document.getElementById("roundtables"))
render(
	<RoundTables
		numTables={6}
		seatsPerTable={[8, 8, 8, 8, 6, 6]}
		dataSource="https://47314db.swoogo-retrofit.tkevents.io"
	/>,
	document.getElementById("roundtables"),
)